/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const overrideCancelBodyExpectedVersionExclusiveMin = 0;
export const overrideCancelBodyExpectedVersionMax = 9007199254740991;

export const OverrideCancelBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(overrideCancelBodyExpectedVersionExclusiveMin)
    .max(overrideCancelBodyExpectedVersionMax),
});

export type OverrideCancelBody = zod.input<typeof OverrideCancelBody>;
export type OverrideCancelBodyOutput = zod.output<typeof OverrideCancelBody>;
